import styles from './GameMechanicsAdvantages.module.scss';
import { AdvantagesHeader } from './AdvantagesHeader/AdvantagesHeader';
import { AdwantagesFooter } from './AdwantagesFooter/AdwantagesFooter';
import { AdvantagesContent } from './AdvantagesContent/AdvantagesContent';

type Props = {
  onStart?: () => void;
  dontShowAgain?: boolean;
  setDontShowAgain?: (value: boolean) => void;
  showFooter?: boolean;
};

export const GameMechanicsAdvantagesModal = ({
  onStart = () => {},
  dontShowAgain = false,
  setDontShowAgain = () => {},
  showFooter = true,
}: Props) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.wrapper}>
        <AdvantagesHeader />

        <AdvantagesContent />

        <AdwantagesFooter
          onStart={onStart}
          dontShowAgain={dontShowAgain}
          setDontShowAgain={setDontShowAgain}
          showButtons={showFooter}
        />
      </div>
    </div>
  );
};
